/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import * as amplify from '@core/Areas/RaceCard/Components/RaceCardContent/Components/LegacyKnockout/ViewModels/AppUtils/Framework/Messaging/amplifyjs'

export function subscribe(topic: string, func: Function, context?: unknown): void {
  if (!topic || !func) {
    if (!PRODUCTION) {
      throw Error('Missing arguments: Unable to subscribe')
    }
    return
  }

  if (context) amplify.subscribe(topic, context, func)
  else amplify.subscribe(topic, func)
}

export function publish(topic: string, ...args: unknown[]): void {
  if (!topic) {
    if (!PRODUCTION) {
      throw Error('Missing arguments: Unable to publish')
    }
    return
  }

  amplify.publish(topic, ...args)
}

export function unsubscribe(topic: string, func: Function): void {
  amplify.unsubscribe(topic, func)
}
